import { stringToHTML } from '../utils/to-html';
import { $Q, $Qll } from '../utils/query-selector';
import { barProgress } from '../utils/bar-progress';
import { interfaceUpsell, loadUpsellCart } from './cart-load-defer';

/**
 * Update cart items section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCartItems = (str) => {
  $Qll('.cartitems-js').forEach((element) => {
    const elementRef = element;
    elementRef.innerHTML = $Q('#cart-items', stringToHTML(str)).outerHTML;
  });
};

/**
 * Update checkout button section in sidecart
 * @param {Object} sections - String list of HTML of section rendering
 */
export const updateCartbutton = (sections) => {
  const str = sections['side-cart'];

  const checkoutBtnSideCart = $Q('.sidecart-checkout-js');
  const btnContainer = $Q('.sidecart-checkout-js', stringToHTML(str));

  updateBarProgress(str);
  updateHeaderCart(str);
  updateButtonCheckout(sections);
  if (!btnContainer || !checkoutBtnSideCart) return;

  const { disabled, textContent } = btnContainer;
  if (!textContent) return;
  checkoutBtnSideCart.disabled = disabled;
  checkoutBtnSideCart.textContent = textContent;
};

/**
 * Update checkout button section in cartpage
 * @param {string} sections - String list of HTML of section rendering
 */
const updateButtonCheckout = (sections) => {
  const str = sections['cart-total'];
  const checkoutBtnCartPage = $Q('.cartpage-checkout-js');

  if (!str || !checkoutBtnCartPage) return;
  const sectionRendering = $Q('.cartpage-checkout-js', stringToHTML(str));
  const { disabled, textContent } = sectionRendering;

  if (!textContent) return;

  checkoutBtnCartPage.disabled = disabled;
  checkoutBtnCartPage.textContent = textContent;
}

/**
 * Update side-cart header (CTA, Cart count)
 * @param {string} str - String HTML of section rendeirng
 */
const updateHeaderCart = (str) => {
  if (!$Q('#cart-header-js')) return;
  const template = stringToHTML(str);

  const count = $Q('#cart-header-js .button-cart-js', template);
  const header = $Q('#cart-header-js', template);

  $Q('header .button-cart-js').innerHTML = count.innerHTML;
  $Q('#cart-header-js').innerHTML = header.innerHTML;
};

/**
 * Update progress bar on cart page and side cart
 * @param {string} str - String HTML of section rendeirng
 */
const updateBarProgress = (str) => {
  const inputBarProgress = $Q('#progress-bar-data', stringToHTML(str));
  const progressBarComponent = $Q('.barprogress-js', stringToHTML(str));
  const footerContainer = $Qll('.container-upsell-js');
  const allProgressBar = $Qll('.barprogress-js');

  if (progressBarComponent && allProgressBar.length < 1) {
    footerContainer.forEach((footer) => {
      if (footer.children.length !== 0) {
        return footer.prepend(progressBarComponent);
      }

      const div = footer;
      div.innerHTML = progressBarComponent.outerHTML;
    });
  }

  if (!inputBarProgress) return allProgressBar.forEach((bar) => bar.remove());
  return barProgress(inputBarProgress);
};

/**
 * Chance all input value only cart page
 *
 * @param {String} id - Variant id item cart
 * @param {String} quantity - Quantity variant by item cart
 */
export const updateQuantity = (id, quantity) => {
  $Qll(`.item-cart-js[id="${id}"]`).forEach((element) => {
    const elementRef = element;
    elementRef.value = quantity;
  });
};

/**
 * Update price item for each item in cart items section
 * @param {string} str - String HTML of section rendeirng
 * @param {number} id - Product ID
 */
export const updatePriceItem = (str, id) => {
  const { dataset, outerText } = $Q(`#price-${id}`, stringToHTML(str));

  $Qll(`.price-${id}`).forEach((element) => {
    const elementRef = element;
    elementRef.innerHTML = outerText;
  });

  updateQuantity(id, dataset.quantity);
};

/**
 * Update total price in cart page
 * @param {string} str - String HTML of section rendeirng
 */
export const updatetotalPrice = (str) => {
  if (!$Q('#cartpage-footer-js')) return;

  if (!$Q('#total-price', stringToHTML(str))) {
    $Q('#cartpage-footer-js').style.display = 'none';
    return;
  }

  if ($Q('#cartpage-price-js') != null) {
    $Q('#cartpage-price-js').innerHTML = $Q(
      '#total-price',
      stringToHTML(str),
    ).outerText;
  }
};

/**
 * Update upsell section in sidecart
 * @param {Object} { 'side-cart', 'cart-page' } - Object of strings HTML of section rendering
 */
export const updateUpsell = async (str) => {
  let cart = $Q('.side-cart');
  let template = str['side-cart']
  const reference = '#cart-upsell-slider';
  const oldContent = $Q(reference);

  if (window.location.href.includes('cart')) {
    cart = $Q('.cartpage')
    template = str['cart-upsell'];
  }

  const content = stringToHTML(template);
  const newContent = $Q(reference, content);

  if (oldContent.dataset.product === newContent.dataset.product) return;

  const [onPage, product] = await interfaceUpsell(cart, content)

  if (product === "") {
    $Q('#upsell-js').innerHTML = newContent.outerHTML;
  }

  if (!onPage) {
    loadUpsellCart(cart);
  }

  document.dispatchEvent(new
    CustomEvent("swym:collections-loaded"));
};
